import { render } from "./DashboardView.vue?vue&type=template&id=fddfeaa0&scoped=true&ts=true"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=fddfeaa0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fddfeaa0"]])

export default __exports__